import type { ReactNode } from 'react';
import { useTracking } from 'react-tracking';
import { ModalHeaderWrapper, CloseButton, CloseIcon } from './styled';

export interface ModalHeaderProps {
  title: ReactNode;
  onClose: () => void;
  disabled?: boolean;
  centered?: boolean;
  hideClose?: boolean;
}

const ModalHeader = ({
  title,
  onClose,
  centered,
  disabled,
  hideClose,
}: ModalHeaderProps) => {
  const { Track, trackEvent } = useTracking({ type: 'track', action: 'click' });
  return (
    <Track>
      <ModalHeaderWrapper centered={centered} data-cy-id="modal-header">
        {typeof title === 'string' ? <h1>{title}</h1> : title}
        {!hideClose && (
          <CloseButton
            type="button"
            disabled={disabled}
            data-cy-id="modal-close-icon-button"
            onClick={() => {
              onClose();
              trackEvent({
                modifier: 'close_icon',
              });
            }}
          >
            <CloseIcon />
          </CloseButton>
        )}
      </ModalHeaderWrapper>
    </Track>
  );
};

export default ModalHeader;
